import {
  setNameSpecification,
  setSpecificationDetail,
} from "@/core/redux/slices/specification";
import { useDispatch, useSelector } from "@/core/redux/store";
import { specificationService } from "@/shared/services/api/specification-service";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function SpecificationSidebarViewModel() {
  const { t } = useTranslation();
  const specificationState = useSelector((state) => state.specification);

  const user = useSelector((state) => state.user.me);
  const categories = useSelector(
    (state) => state.specification.filteredCategories
  );
  const searchTerm = useSelector((state) => state.specification.searchTerm);

  const { items, subCategories, mainCategories } = useSelector(
    (state) => state.specification.changedValues
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const setName = (name: string) => {
    dispatch(setNameSpecification(name));
  };

  const updateSpecification = useCallback(
    async (name: string) => {
      if (
        !user?.company.id ||
        !specificationState.specification.specification.id
      )
        return;
      const response = await specificationService.updateSpecification({
        companyId: user?.company.id,
        specificationId: specificationState.specification.specification.id,
        name: name,
      });

      if (response.success) {
        dispatch(setSpecificationDetail(response.data));
      }

      return response;
    },
    [user?.company.id, specificationState.specification.specification.id]
  );

  const debouncedUpdateSpecification = useMemo(
    () =>
      debounce(async (name: string) => {
        await updateSpecification(name);
      }, 1000),
    [
      updateSpecification,
      user?.company.id,
      specificationState.specification.specification.id,
    ]
  );

  const handleChangeName = useCallback(
    (name: string) => {
      if (
        !user?.company.id ||
        !specificationState.specification.specification.id
      ) {
        console.warn("Gerekli ID'ler eksik");
        return;
      }
      debouncedUpdateSpecification(name);
    },
    [
      debouncedUpdateSpecification,
      user?.company.id,
      specificationState.specification.specification.id,
    ]
  );

  useEffect(() => {
    return () => {
      debouncedUpdateSpecification.cancel();
    };
  }, [debouncedUpdateSpecification]);

  return {
    t,
    specification: specificationState,
    activeSpefification: specificationState.activeSpecificationStep,
    navigate,
    categories,
    searchTerm,
    setName,
    updateSpecification,
    dispatch,
    handleChangeName,
    items,
    subCategories,
    mainCategories,
  };
}
